import { observer } from "mobx-react-lite"

import { Card } from "@/components/card"
import { useScaleApplication } from "@/domains/application/use-scale-application"
import { SettingsSectionTitle } from "@/domains/settings/components/settings-section-title"

import { FEATURE_FLAG_REGISTRY } from "../types"
import { FeatureFlagToggle } from "./feature-flag-toggle"

export const FeatureFlagsSettingsSection = observer(() => {
  const scaleApp = useScaleApplication()

  if (!scaleApp) {
    return null
  }

  // No flags registered — hide the section entirely rather than render an
  // empty "Feature Flags" card. The machinery (store, events, toggle UI) is
  // still wired so a single `FEATURE_FLAG_REGISTRY` entry re-enables it.
  if (FEATURE_FLAG_REGISTRY.length === 0) {
    return null
  }

  const featureFlagsStore = scaleApp.FeatureFlags.Store

  return (
    <Card.Container className="mb-8 flex max-w-4xl flex-col gap-6 rounded-lg border border-p400-light bg-p400 p-4 pb-8 text-t100 lg:p-6">
      <div className="relative text-t100">
        <SettingsSectionTitle
          title="Feature Flags"
          subtitle="Enable experimental features and beta functionality. These features may be unstable or incomplete."
        />
        <div className="space-y-3">
          {FEATURE_FLAG_REGISTRY.map((flag) => (
            <FeatureFlagToggle
              key={flag.id}
              flagId={flag.id}
              name={flag.name}
              description={flag.description}
              enabled={featureFlagsStore.isEnabled(flag.id)}
              onToggle={(flagId) => featureFlagsStore.toggleFlag(flagId)}
            />
          ))}
        </div>
      </div>
    </Card.Container>
  )
})
